import { generateUniqueId } from "helpers/generic";
import { AppAction } from "redux/store";

import notificationReducer from "redux/reducers/notificationReducer";

import { IOvhCatalogAPI, IOvhPriceRange } from "types/api/ovhApiInterface";

import { ApiService } from "service/ApiService";

export const getOvhCatalog = (): AppAction<Promise<Array<IOvhCatalogAPI>>> => async (dispatch) => {
 try {
  const { data } = await ApiService<Array<IOvhCatalogAPI>>("/server/ovh/getcatalog");
  return data;
 } catch (error: any) {
  dispatch(
   notificationReducer.actions.addAlert({
    id: generateUniqueId(),
    message: `Failed to get ovh catalog - ${error?.message || "unknown error"}`,
    timestamp: Date.now(),
    type: "error"
   })
  );
  return [];
 }
};

export const getOvhPrices = (): AppAction<Promise<Array<IOvhPriceRange>>> => async (dispatch) => {
 try {
  const { data } = await ApiService<Array<IOvhPriceRange>>("/server/ovh/getprices");
  return data;
 } catch (error: any) {
  dispatch(
   notificationReducer.actions.addAlert({
    id: generateUniqueId(),
    message: `Failed to get ovh prices - ${error?.message || "unknown error"}`,
    timestamp: Date.now(),
    type: "error"
   })
  );
  return [];
 }
};

export const postCreateOvhServer =
 (
  name: string,
  server_type_finalized: string,
  vps_os: string,
  planCode: string,
  vps_datacenter: string,
  business_continuity: boolean,
  amount: number,
  mail_pro_mailbox: number,
  coupon_id?: number
 ): AppAction<Promise<void>> =>
 async (dispatch) => {
  try {
   await ApiService("/server/ovh/createserver", "POST", {
    name,
    server_type_finalized,
    vps_os,
    planCode,
    vps_datacenter,
    business_continuity,
    amount,
    mail_pro_mailbox: server_type_finalized === "container-mail-pro" ? mail_pro_mailbox : 0,
    coupon_id
   });
   dispatch(
    notificationReducer.actions.addAlert({
     id: generateUniqueId(),
     message: "Creating OVH server...",
     timestamp: Date.now(),
     type: "info"
    })
   );
  } catch (error: any) {
   dispatch(
    notificationReducer.actions.addAlert({
     id: generateUniqueId(),
     message: `Failed to create OVH server - ${error?.message || "unknown error"}`,
     timestamp: Date.now(),
     type: "error"
    })
   );
  }
 };
